import type { ReactNode } from 'react';
import { Box, Grid, Stack } from '@mui/material';
import { EmptyState } from '../common/EmptyState';

export interface ResultsLayoutProps {
  /** Sol sütun filtre paneli (md+ görünür). */
  filters?: ReactNode;
  /** Sonuç listesinin üstündeki sıralama/sayaç satırı. */
  toolbar?: ReactNode;
  loading?: boolean;
  /** Sonuç yoksa. Verilmezse varsayılan `EmptyState`. */
  emptyState?: ReactNode;
  /** Sonuç sayısı 0 mı? (loading değilken emptyState'i tetikler.) */
  isEmpty?: boolean;
  children: ReactNode;
  /** İkinci sütun (uçak gidiş-dönüş, çok noktalı vs.). */
  secondaryPane?: ReactNode;
}

/** Sonuç adımı yerleşimi — opsiyonel filtre sidebar'ı + toolbar + kart listesi.
 *  Bugün Air/Hotel kendi sidebar'larını icat ediyor, Bus/Transfer/RentCar'da hiç yok. */
export function ResultsLayout({
  filters,
  toolbar,
  loading = false,
  emptyState,
  isEmpty = false,
  children,
  secondaryPane,
}: ResultsLayoutProps) {
  const showEmpty = !loading && isEmpty;

  const list = (
    <Stack spacing={2}>
      {toolbar}
      {showEmpty
        ? emptyState ?? <EmptyState title="Aramanıza uygun sonuç bulunamadı." />
        : children}
    </Stack>
  );

  if (!filters) {
    return secondaryPane ? (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>{list}</Grid>
        <Grid size={{ xs: 12, md: 6 }}>{secondaryPane}</Grid>
      </Grid>
    ) : (
      <Box>{list}</Box>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 3 }} sx={{ display: { xs: 'none', md: 'block' } }}>
        {filters}
      </Grid>
      <Grid size={{ xs: 12, md: secondaryPane ? 9 : 9 }}>
        {secondaryPane ? (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, lg: 6 }}>{list}</Grid>
            <Grid size={{ xs: 12, lg: 6 }}>{secondaryPane}</Grid>
          </Grid>
        ) : (
          list
        )}
      </Grid>
    </Grid>
  );
}
